export const isMobile = /iphone|ipod|android|ie|blackberry|fennec/.test(
  navigator.userAgent.toLowerCase(),
);

export const getEventName = (competitor) => {
  if (competitor?.name) return competitor.name;

  return competitor.type === 1 ? competitor?.teamName || '' : competitor?.playerName || '';
};
